import { Observable } from "rxjs";
import { inject, injectable } from "tsyringe";

import { RepaymentObligationsRepository } from "src/containers/repayment-obligations/repositories/repayment-obligation/repayment-obligation-repository";
import { map } from "rxjs/operators";
import { autoBind } from "src/shared/decorators/autobind";
import { RepaymentObligation } from "src/containers/repayment-obligations/models/repayment-obligation";

@injectable()
export class RepaymentObligationsService {
    constructor(
        @inject("RepaymentObligationsRepository")
        private repository: RepaymentObligationsRepository
    ) {}

    @autoBind
    getObligations(): Observable<Array<RepaymentObligation>> {
        return this.repository
            .getObligations()
            .pipe(
                map((data) =>
                    data.map((json) =>
                        RepaymentObligation.fromJson<RepaymentObligation>(json)
                    )
                )
            );
    }
}
